<!-- 车辆信息下发接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode":"2KNTYVWC",
                "ownerId":"001",
                "carNo":"粤YAA123",
                "operateTime":"2017-07-04 13:14:15",
                "operator":"operaotr"},
            responseCode: 	{
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台下发某个车辆信息",
                t_url: this.commonUrls.test+"addVipCar",
                p_url: this.commonUrls.prod+"addVipCar",
                precondition: "VEMS 2.10.5及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'ownerId', info2: '是', info3: 'String', info4: '车主ID，外部平台分配的车主ID，用于唯一识别一个车主' },
                        { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'carLicenseType', info2: '否', info3: 'String', info4: '车牌类型, 0默认' },
                        { info1: 'carColor', info2: '否', info3: 'Integer', info4: '车辆颜色, 0默认' },
                        { info1: 'carLogo', info2: '否', info3: 'Integer', info4: '车辆品牌, 0默认' },
                        { info1: 'carModel', info2: '否', info3: 'Integer', info4: '品牌型号' },
                        { info1: 'carType', info2: '否', info3: 'Integer', info4: '车辆类型, 0默认' },
                        { info1: 'carOwnType', info2: '否', info3: 'Integer', info4: '车归属类型，0未知，1公车，2私车' },
                        { info1: 'carSizeType', info2: '否', info3: 'Integer', info4: '车辆大小类型，0未知，1小车，2大车，3超大车，4中型车' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '备注' },
                        { info1: 'operator', info2: '是', info3: 'String', info4: '操作员' },
                        { info1: 'operateTime', info2: '是', info3: 'String', info4: '操作时间，yyyy-MM-dd HH:mm:ss' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/vip/addVipCar.vue